module.exports = __webpack_public_path__ + "static/media/website-home-logo.b80d56d6.svg";